import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomLabel from '@s-ui/react-atom-label'
import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import IconShieldCheckOutline from '@adv-mt/mt-svg-icons/lib/ShieldCheckOutline.js'

import FormHasWarranty from './index.js'

const LEGACY_WRAPPER = 'legacy'
const CHECKED_ID = 'checked'

const FormCardHasWarranty = ({id, type, value, onChange, withLabel, wrapper = LEGACY_WRAPPER}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {checked}) => {
    onChange(e, {
      field: FILTER_NAMES.HAS_WARRANTY,
      value: checked,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_WARRANTY]
    })
  }

  const handleChecked = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    _handleOnChange(null, {checked: currentValue === CHECKED_ID})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <div className="mt-FormCardHasWarranty">
        <div className="mt-FormCardHasWarranty-labelWrapper">
          <AtomLabel text={i18n.t('COMMON.WARRANTY')} />
          <span className="mt-FormCardHasWarranty-labelIconWrapper">
            <IconShieldCheckOutline />
          </span>
        </div>
        <FormHasWarranty
          helpText={i18n.t('COMMON.SECURE_PURCHASE_HELP_INFO')}
          id={id}
          label={i18n.t('COMMON.SECURE_PURCHASE_LABEL')}
          onChange={onChange}
          value={value}
        />
      </div>
    )
  }

  const iconLabel = (
    <span className="mt-FormCardHasWarranty-labelIconWrapper">
      <IconShieldCheckOutline />
    </span>
  )

  return (
    <FilterWrapperBasic
      filters={[
        {
          nodeLabel: iconLabel,
          label: i18n.t('COMMON.WARRANTY'),
          name: FILTER_NAMES.HAS_WARRANTY,
          options: [{id: CHECKED_ID, label: i18n.t('COMMON.SECURE_PURCHASE_LABEL')}],
          showLabel: true,
          type
        }
      ]}
      group={`${FILTER_NAMES.HAS_WARRANTY}Group`}
      helpText={i18n.t('COMMON.SECURE_PURCHASE_HELP_INFO')}
      legend={i18n.t('COMMON.WARRANTY')}
      legendIcon={iconLabel}
      onChange={handleChecked}
      showLegend={withLabel}
      value={{[FILTER_NAMES.HAS_WARRANTY]: value ? [CHECKED_ID] : []}}
      wrapper={wrapper}
    />
  )
}

FormCardHasWarranty.displayName = 'FormCardHasWarranty'
FormCardHasWarranty.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.bool,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormCardHasWarranty
